module.exports = __webpack_public_path__ + "static/client_3-65ad3ea1e648fd8b16f5c2621ab59ef5.png";